<template>
  <li><slot /></li>
</template>
